import { createFileRoute, redirect } from '@tanstack/react-router';
import { BranchesPage, merchantBranchesQueryOptions } from '@/features/branches';
import { isMerchantOwner } from '@/lib/auth/rbac';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/branches')({
  beforeLoad: () => {
    if (!isMerchantOwner(useAuthStore.getState().user?.role)) {
      throw redirect({
        to: '/dashboard',
        search: { period: 'today' },
        replace: true,
      });
    }
  },
  loader: ({ cause, context }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(merchantBranchesQueryOptions());
  },
  component: BranchesPage,
});
